/* affiliates.js: the affiliate landing (CONTRACT-SITE §2.12). AFF is pinned to plans.ts + the 018 seed by affiliates.test.js. */
(function () {
'use strict';
var AFF = { percentBps: 2000, discountBps: 2000, priceCents: { monthly: 19900, yearly: 99900 }, holdDays: { monthly: 14, yearly: 30 }, cookieDays: 90, minPayoutCents: { bank: 10000, usdt: 2500 } };
var AFF_LEVELS = [ { id: 'starter', name: 'Starter', min: 0 }, { id: 'builder', name: 'Builder', min: 1 }, { id: 'closer', name: 'Closer', min: 5 }, { id: 'partner', name: 'Partner', min: 15 }, { id: 'legend', name: 'Legend', min: 50 } ];
function rhu(a, bps) { return Math.floor((a * bps + 5000) / 10000); }
AFF.commissionCents = { monthly: rhu(AFF.priceCents.monthly, AFF.percentBps), yearly: rhu(AFF.priceCents.yearly, AFF.percentBps) };
AFF.discountedPriceCents = { monthly: rhu(AFF.priceCents.monthly, 10000 - AFF.discountBps), yearly: rhu(AFF.priceCents.yearly, 10000 - AFF.discountBps) };
AFF.firstCycleCents = { monthly: rhu(AFF.discountedPriceCents.monthly, AFF.percentBps), yearly: rhu(AFF.discountedPriceCents.yearly, AFF.percentBps) };
/* data-aff-copy="off" (§2.15): first cycles at the renewal rate. */
AFF.tiers = function (on) { var c = AFF.commissionCents, f = on ? AFF.firstCycleCents : c; return { Mf: f.monthly, Mr: c.monthly, Yf: f.yearly, Yr: c.yearly }; };
function levelFor(n) {
  var i = 0; while (i + 1 < AFF_LEVELS.length && n >= AFF_LEVELS[i + 1].min) i++;
  var next = AFF_LEVELS[i + 1] || null;
  return { level: AFF_LEVELS[i], next: next, toNext: next ? next.min - n : 0 };
}
/* calc({r, y, R}, on): integer cents, summed in tenths, rounded once (§2.7). */
function calc(o, on) {
  var T = AFF.tiers(on), r = o.r, y10 = Math.round(o.y * 10), R = o.R, m = r * (10 - y10), yy = r * y10, sum = 0, months = [];
  function t(x) { return Math.floor((x + 5) / 10); }
  for (var k = 1; k <= 12; k++) { var mx = m * (T.Mf + Math.min(k - 1, R - 1) * T.Mr) + yy * T.Yf; sum += mx; months.push(t(mx)); }
  var e1x = m * T.Mf + yy * T.Yf, e12 = t(sum), y12 = t(12 * yy * T.Yf), first12 = t(12 * e1x);
  return { e1: t(e1x), e12: e12, y12: y12, m12: e12 - y12, first12: first12, renew12: e12 - first12, ess: months[11], y2: t(12 * yy * T.Yr), months: months };
}
AFF.calc = calc;
window.AFF = AFF; window.AFF_LEVELS = AFF_LEVELS; window.affLevelFor = levelFor;

var D = document;
function $(s, e) { return (e || D).querySelector(s); }
function $$(s, e) { return [].slice.call((e || D).querySelectorAll(s)); }
function rm() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
function money(c) { var n = Math.abs(c); return (c < 0 ? '−' : '') + 'US$' + (n / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
AFF.money = money;
function on() { return D.body.getAttribute('data-aff-copy') === 'on'; }
function io(els, opts, fn) {   // once each
  if (!els.length) return;
  if (!window.IntersectionObserver) { els.forEach(fn); return; }
  var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { o.unobserve(e.target); try { fn(e.target); } catch (x) {} } }); }, opts);
  els.forEach(function (el) { o.observe(el); });
}
function hot(el, ms) { if (!el || rm()) return; el.classList.add('is-hot'); setTimeout(function () { el.classList.remove('is-hot'); }, ms || 300); }
/* affCount(el, {to, from, decimals, prefix, suffix, ms, fmt}) */
function affCount(el, o) {
  var from = o.from !== undefined ? o.from : Number(el.getAttribute('data-aff-from') || 0), d = o.decimals || 0, ms = o.ms || 1500, raf = 0, t0 = 0;
  function txt(v) { return o.fmt ? o.fmt(v) : (o.prefix || '') + v.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d }) + (o.suffix || ''); }
  if (rm() || D.hidden) { el.textContent = txt(o.to); return function () {}; }
  raf = requestAnimationFrame(function step(ts) {
    t0 = t0 || ts; var p = Math.min(1, (ts - t0) / ms), v = from + (o.to - from) * (1 - Math.pow(1 - p, 3));
    el.textContent = txt(p < 1 ? (o.fmt ? Math.round(v) : v) : o.to);
    if (p < 1) raf = requestAnimationFrame(step); else if (o.onDone) o.onDone();
  });
  return function () { cancelAnimationFrame(raf); };
}
function fillMoney() { $$('[data-aff-cents]').forEach(function (el) { el.textContent = money(Number(el.getAttribute('data-aff-cents'))); }); }
function counts() {
  io($$('[data-aff-count]'), { threshold: 0.5 }, function (el) {
    affCount(el, { to: Number(el.getAttribute('data-aff-count')), from: 0, decimals: Number(el.getAttribute('data-aff-decimals') || 0), prefix: el.getAttribute('data-aff-prefix') || '', suffix: el.getAttribute('data-aff-suffix') || '' });
  });
}

/* ---- the calculator (§2.7) ---- */
var WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];
function words(n) { return n <= 12 ? WORDS[n] : String(n); }
function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
function calculator() {
  var card = $('[data-aff-calc]'); if (!card) return;
  var refs = $('#calc-refs'), mix = $('#calc-mix'), stay = $('#calc-stay'), horizon = 12, last = null, stopBig = null, flash = 0;
  var radios = $$('.aff-calc-horizon [role=radio]', card);
  function trackFill(i) { i.style.setProperty('--p', ((i.value - i.min) / (i.max - i.min) * 100) + '%'); }
  function setMoney(id, c) { var el = D.getElementById(id); if (el) el.textContent = money(c); return el; }
  function render(animate) {
    var r = Number(refs.value), y = Number(mix.value) / 100, R = Number(stay.value), c = calc({ r: r, y: y, R: R }, on());
    var big = horizon === 1 ? c.e1 : c.e12, bigEl = D.getElementById('calc-big');
    [refs, mix, stay].forEach(trackFill);
    [['calc-refs-out', r, ''], ['calc-mix-out', Number(mix.value), '%'], ['calc-stay-out', R, '']].forEach(function (o) {
      var el = D.getElementById(o[0]), prev = parseFloat(el.textContent) || 0;
      if (animate && prev !== o[1]) affCount(el, { from: prev, to: o[1], suffix: o[2], ms: 240 }); else el.textContent = o[1] + o[2];
    });
    if (stopBig) stopBig();
    if (animate && last !== null) stopBig = affCount(bigEl, { from: last, to: big, ms: 400, fmt: money }); else bigEl.textContent = money(big);
    last = big;
    D.getElementById('calc-big-label').textContent = horizon === 1 ? 'in your first month' : 'in 12 months';
    setMoney('calc-first12', horizon === 1 ? c.e1 : c.first12); setMoney('calc-renew12', horizon === 1 ? 0 : c.renew12);
    setMoney('calc-ess', c.ess); setMoney('calc-y12', c.y12); setMoney('calc-m12', c.m12); setMoney('calc-y2', c.y2); setMoney('calc-mlast', c.ess); setMoney('calc-m1', c.e1);
    var y2row = $('.aff-calc-y2', card); if (y2row) y2row.hidden = y === 0;
    var s = D.getElementById('calc-sentence'), m = $$('.aff-money', s), share = y === 0 ? 'none' : y === 1 ? 'all' : words(Math.round(y * 10)) + ' in ten';
    if (s && m.length === 3) {
      var vals = [c.e1, c.ess, c.e12];
      s.firstChild.nodeValue = cap(words(r)) + ' referral' + (r === 1 ? '' : 's') + ' a month, ' + share + ' on Yearly, Monthly customers staying ' + words(R) + ' month' + (R === 1 ? '' : 's') + ' — ';
      m.forEach(function (el, i) { var t = money(vals[i]); if (el.textContent !== t) { el.textContent = t; if (animate) hot(el, 300); } });
    }
    var max = c.months[11] || 1;
    $$('.aff-month', card).forEach(function (b, i) { b.style.setProperty('--f', (c.e1 / max).toFixed(2)); b.style.setProperty('--r', ((c.months[i] - c.e1) / max).toFixed(2)); b.style.setProperty('--n', i); });
    if (animate && !rm()) { card.classList.add('is-changed'); clearTimeout(flash); flash = setTimeout(function () { card.classList.remove('is-changed'); }, 600); }
  }
  [refs, mix, stay].forEach(function (i) { i.disabled = false; i.addEventListener('input', function () { render(true); }); });
  radios.forEach(function (b, i) {
    b.disabled = false;
    b.addEventListener('click', function () { choose(i); });
    b.addEventListener('keydown', function (e) {
      var k = e.key, n = k === 'ArrowRight' || k === 'ArrowDown' ? 1 : k === 'ArrowLeft' || k === 'ArrowUp' ? -1 : 0;
      if (n) { e.preventDefault(); choose((i + n + radios.length) % radios.length); radios[(i + n + radios.length) % radios.length].focus(); }
    });
  });
  function choose(i) {
    radios.forEach(function (b, j) { b.setAttribute('aria-checked', String(i === j)); b.tabIndex = i === j ? 0 : -1; });
    horizon = Number(radios[i].getAttribute('data-horizon')); render(true);
  }
  radios.forEach(function (b) { b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1; });
  render(false);
  var months = $('.aff-months', card);
  if (months) { if (rm()) months.classList.add('is-in'); else io([months], { threshold: 0.4 }, function (el) { el.classList.add('is-in'); }); }
}

/* ---- sticky bar + signed-in swap (§2.10) ---- */
function sticky() {   // every width; the cookie card rides above it
  var bar = D.getElementById('affSticky'), H = D.documentElement; if (!bar || !window.IntersectionObserver) return;
  var seen = { hero: true, foot: false }, hero = $('.hero'), foot = $('.footer');
  function update() { var ok = !seen.hero && !seen.foot; bar.classList.toggle('visible', ok); H.classList.toggle('aff-sticky-on', ok); if (ok) H.style.setProperty('--aff-sticky-h', bar.offsetHeight + 'px'); }
  var o = new IntersectionObserver(function (es) { es.forEach(function (e) { seen[e.target === hero ? 'hero' : 'foot'] = e.isIntersecting; }); update(); });
  if (hero) o.observe(hero); if (foot) o.observe(foot);
  if (window.MutationObserver) new MutationObserver(update).observe(D.documentElement, { attributes: true, attributeFilter: ['class'] });
}
function signedIn() {
  try {
    if (!window.InterviewAuth || !InterviewAuth.token()) return;
    $$('[data-aff-cta]').forEach(function (a) { a.href = '/affiliates/portal.html#overview'; var l = $('.btn-label', a); if (l) l.textContent = 'Open your affiliate dashboard'; });
    $$('[data-aff-login]').forEach(function (a) { a.hidden = true; });
  } catch (e) {}
}

/* ---- step mini-UIs (§2.6) ---- */
function steps() {
  var reduced = rm();
  $$('.aff-step').forEach(function (card) {
    var box = $('.aff-link-box[data-aff-type]', card), copy = $('[data-aff-copy-demo]', card), tl = $('.aff-timeline--mini', card), line = tl && $('.aff-tl-line', tl);
    if (reduced) return;
    if (line) line.style.setProperty('--k', 0);
    if (copy) copy.setAttribute('data-ready', '1');
    io([card], { threshold: 0.6 }, function () {
      if (box) {
        var full = box.getAttribute('data-aff-type'), i = 0; box.style.minHeight = box.offsetHeight + 'px'; box.textContent = '';
        setTimeout(function tick() { box.textContent = full.slice(0, ++i); if (i < full.length) setTimeout(tick, 40); }, 300);
      }
      if (copy) setTimeout(function () { copy.classList.add('is-done'); $('.btn-label', copy).textContent = 'Copied ✓'; }, 1200);
      if (line) setTimeout(function () { line.style.transition = 'none'; line.style.setProperty('--k', 1); line.style.removeProperty('transition'); }, 60);
    });
  });
}

/* ---- the mock loader (§2.11) ---- */
function demo() {
  var fig = $('figure.aff-dash[data-demo-player]'); if (!fig) return;
  var src = fig.getAttribute('data-demo-player'), done = false;
  function inject() { if (done) return; done = true; var s = D.createElement('script'); s.src = src; s.async = true; D.body.appendChild(s); }
  function arm() { io([fig], { rootMargin: '300px 0px' }, inject); }
  if (D.readyState === 'complete') arm(); else addEventListener('load', arm, { once: true });
  addEventListener('scroll', arm, { once: true, passive: true });
}

/* ---- tilt, ladder, mission (§2.2b/2.8b/2.4b), offer rows ---- */
function tilt() {
  var fig = $('[data-aff-tilt]');
  if (!fig || rm() || innerWidth < 980 || !matchMedia('(pointer: fine)').matches) return;
  var frame = $('.demo-frame', fig), flt = $('.aff-demo-float', fig), glare = $('.aff-glare', fig), raf = 0, px = 0.5, py = 0.5;
  function paint() {
    raf = 0;
    frame.style.transform = 'perspective(1200px) rotateX(' + ((0.5 - py) * 6).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 8).toFixed(2) + 'deg)';
    if (flt) flt.style.transform = 'translate3d(' + ((px - 0.5) * 18).toFixed(1) + 'px,' + ((py - 0.5) * 14).toFixed(1) + 'px,0)';
    if (glare) { glare.style.setProperty('--gx', (px * 100).toFixed(1) + '%'); glare.style.setProperty('--gy', (py * 100).toFixed(1) + '%'); }
  }
  fig.addEventListener('pointermove', function (e) {
    var b = fig.getBoundingClientRect(); px = (e.clientX - b.left) / b.width; py = (e.clientY - b.top) / b.height;
    fig.classList.remove('is-rest'); if (!raf) raf = requestAnimationFrame(paint);
  });
  fig.addEventListener('pointerleave', function () { if (raf) cancelAnimationFrame(raf); raf = 0; fig.classList.add('is-rest'); frame.style.transform = ''; if (flt) flt.style.transform = ''; });
}
function ladder() {
  var lad = $('[data-aff-ladder]'); if (!lad) return;
  var line = $('.aff-ladder-line i', lad), rungs = $$('.aff-rung', lad);
  function light() { lad.classList.add('is-in'); line.style.setProperty('--k', 1); rungs.forEach(function (r, i) { if (rm()) r.classList.add('is-lit'); else setTimeout(function () { r.classList.add('is-lit'); }, i * 220); }); }
  if (rm()) { light(); return; }
  line.style.setProperty('--k', 0);
  io([lad], { threshold: 0.5 }, function () { requestAnimationFrame(light); });
}
function mission() {
  var beats = $$('.aff-beat');
  if (rm()) { beats.forEach(function (b) { b.classList.add('is-in'); }); return; }
  io(beats, { threshold: 0.55 }, function (b) { b.classList.add('is-in'); });   // the art scrubs by CSS where view() exists
}
function offer() {
  var rows = $$('.value-stack--aff .stack-row');
  if (rm()) { rows.forEach(function (r) { r.classList.add('is-in'); }); return; }
  io(rows, { threshold: 0.6 }, function (r) { r.classList.add('is-in'); });
}

/* ---- the four promises + the Launch Kit: their CSS motion runs once each block is in view ---- */
function inview() {
  var els = $$('.aff-promise, .aff-kit-wall, .aff-kit-diy');
  if (rm()) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  io(els, { threshold: 0.35 }, function (e) { e.classList.add('is-in'); });
}

function boot() {
  [fillMoney, counts, calculator, sticky, signedIn, steps, demo, tilt, ladder, mission, offer, inview].forEach(function (f) { try { f(); } catch (e) {} });
}
if (/^\/admin(\/|$)/.test(location.pathname)) return;
if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
